import React from "react";
import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import spanGroup from "../../assets/icons/animated-horizontal-lines-dark.gif";
import cellphoneImg from "../../assets/images/croped-cellphone.png";
import cellImg from "../../assets/images/cell-phone-img-mobile.png";
import exesGroup from "../../assets/icons/exex-group-dark.svg";
import darkBackArrows from "../../assets/icons/dark-back-arrows.png";
import AppButton from "../app-button";
import PlatformBox from "../platform-box";

const sxStyles = {
  mainContainer: {
    display: "flex",
    width: "100%",
    height: { xs: "900px", md: "775px" },
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "center",
    position: "relative",
    backgroundColor: "#FED301",
  },
  content: {
    display: "flex",
    width: { xs: "100%", lg: "1440px" },
    maxWidth: "1440px",
    backgroundColor: "#FED301",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "center",
    paddingTop: { xs: "50px", md: "" },
  },
  titleFirstHalf: {
    color: "black",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    lineHeight: { xs: "35px", md: "64px" },
    fontWeight: "600",
    alignSelf: { xs: "left", md: "left" },
  },
  titleSecondHalf: {
    color: "black",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "35px", md: "64px" },
    lineHeight: { xs: "35px", md: "64px" },
    fontWeight: "bold",
    marginBottom: "15px",
    marginTop: "10px",
  },
  titleContainer: {
    display: "flex",
    marginBottom: "24px",
    width: "100%",
    alignItems: { xs: "center", md: "flex-start" },
    textAlign: { xs: "center", md: "left" },
    paddingTop: { xs: "0px", md: "250px" },
    alignSelf: { xs: "center", md: "flex-start" },
    paddingLeft: { xs: "20px", md: "100px" },
  },
};
const CellphoneSection = () => {
  const matches = useMediaQuery("(max-width:600px)");
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Box
        sx={{
          position: "absolute",
          left: { xs: "120px", md: "930px" },
          top: { xs: "480px", md: "170px" },
          height: { xs: "18px", md: "30px" },
          width: { xs: "150px", md: "320px" },
        }}
      >
        <img src={exesGroup} style={{ height: "auto", width: "auto" }} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: "75px",
          top: "750px",
          display: { xs: "none", md: "block" },
        }}
      >
        <img src={exesGroup} style={{ height: "30px", width: "320px" }} />
      </Box>
      <img
        src={spanGroup}
        style={{
          position: "absolute",
          left: "800px",
          top: "320px",
          height: "25px",
          width: "70px",
        }}
      />
      <img
        src={spanGroup}
        style={{
          position: "absolute",
          left: "800px",
          top: "340px",
          height: "25px",
          width: "70px",
        }}
      />
      <img
        src={spanGroup}
        style={{
          position: "absolute",
          left: "800px",
          top: "360px",
          height: "25px",
          width: "70px",
        }}
      />
      <img
        src={spanGroup}
        style={{
          position: "absolute",
          left: "800px",
          top: "380px",
          height: "25px",
          width: "70px",
        }}
      />
      <img
        src={spanGroup}
        style={{
          position: "absolute",
          left: "800px",
          top: "400px",
          height: "25px",
          width: "70px",
        }}
      />
      <img
        src={darkBackArrows}
        style={{
          width: "65px",
          height: "20px",
          position: "absolute",
          top: "550px",
          left: "570px",
        }}
      />
      <Stack sx={sxStyles.content}>
        <Stack sx={sxStyles.titleContainer}>
          <Typography sx={sxStyles.titleFirstHalf}>¡ESTO VA A SER</Typography>
          <Typography sx={sxStyles.titleSecondHalf}> ÉPICO!</Typography>
          <Typography sx={sxStyles.titleSecondHalf}>¿COMENZAMOS?</Typography>
          <Box
            sx={{
              marginTop: { xs: "25px", md: "40px" },
              marginBottom: { xs: "55px", md: 0 },
            }}
          >
            <PlatformBox />
            {/*<AppButton bgColor={"black"} color={"white"} />*/}
          </Box>
        </Stack>
        <Box
          sx={{
            display: "flex",
            width: "800px",
            justifyContent: "flex-end",
          }}
        >
          {matches ? (
            <img src={cellImg} style={{ paddingRight: "420px" }} />
          ) : (
            <img src={cellphoneImg} />
          )}
        </Box>
      </Stack>
    </Grid>
  );
};

export default CellphoneSection;
